import type {IValidatorConfig, TPasswordErrors} from "~/shared/interfaces/validator";
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      partsValidation: {
        errorTypesList: {
          required: 'content_exist',
          specifySize: 'content_specify_length',
          minLength: 'content_min_length',
          maxLength: 'content_max_length',
          emailFormat: 'email_format',
          phoneFormat: 'phone_format',
          passwordFormat: 'password_format',
          compareWith: 'content_compare',
        },
        validator: function (
          settings: IValidatorConfig,
          inputValue: string,
        ) {
          const {
            required,
            minLength,
            maxLength,
            emailFormat,
            phoneFormat,
            passwordFormat,
            compareWith,
          } = settings;

          let errorInfo

          if (passwordFormat) {
            errorInfo = {
              errorText: '',
              errorType: '',
              hasError: false,
              passwordErrors: <TPasswordErrors[]>[]
            }
          } else {
            errorInfo = {
              errorText: '',
              errorType: '',
              hasError: false,
            }
          }

    if (required && !inputValue.trim()) {
      if (emailFormat) {
        errorInfo.errorText = 'Введите e-mail';
      } else {
        errorInfo.errorText = 'Поле должно быть заполнено';
      }
      errorInfo.errorType = this.errorTypesList.required;
      if (passwordFormat) {
        errorInfo.passwordErrors = ['length', 'numbers', 'lower', 'upper', 'symbol']
      }
    } else if (
      inputValue.length &&
      minLength != null &&
      minLength === maxLength &&
      inputValue.length != maxLength
    ) {
      errorInfo.errorText = `Длина поля ${minLength} символов`;
      errorInfo.errorType = this.errorTypesList.specifySize;
    } else if (inputValue.length && minLength != null && inputValue.length < minLength) {
      errorInfo.errorText = `Не меньше ${minLength} символов`;
      errorInfo.errorType = this.errorTypesList.minLength;
    } else if (inputValue.length && maxLength != null && inputValue.length > maxLength) {
      errorInfo.errorText = `Не больше ${maxLength} символов`;
      errorInfo.errorType = this.errorTypesList.maxLength;
    } else if (emailFormat) {
      const isRightEmail = this._validateEmail(inputValue);
      if (!isRightEmail) {
        errorInfo.errorText = 'Неверный формат эл. почты';
        errorInfo.errorType = this.errorTypesList.emailFormat;
      }
    } else if (phoneFormat) {
      const isRightPhone = this._validatePhone(inputValue);

            if (!isRightPhone) {
              errorInfo.errorText = 'Неправильный формат номера';
              errorInfo.errorType = this.errorTypesList.phoneFormat;
            }
          } else if (passwordFormat) {
            const isRightPassword = this._validatePassword(inputValue)

            if (!isRightPassword) {
              errorInfo.errorText = 'Неправильный формат пароля';
              errorInfo.errorType = this.errorTypesList.passwordFormat;

        // TODO подумать в будущем как отрефакторить
        if (!/(?=.*[@$№`!%*?&^#()_+={}\[\]:;"'<>,.?/~|\\-])/.test(inputValue)) {
          errorInfo.passwordErrors?.push('symbol')
        }
        if (!/(?=.*[a-z])/.test(inputValue)) {
          errorInfo.passwordErrors?.push('lower')
        }
        if (!/(?=.*[A-Z])/.test(inputValue)) {
          errorInfo.passwordErrors?.push('upper')
        }
        if (!/(?=.*[0-9])/.test(inputValue)) {
          errorInfo.passwordErrors?.push('numbers')
        }
        if (inputValue.length < 8) {
          errorInfo.passwordErrors?.push('length')
        }
      }
    } else if (compareWith && compareWith.elementId) {
      const compareInput = document.getElementById(compareWith.elementId) as HTMLInputElement;
      if (compareInput && inputValue != compareInput.value) {
        errorInfo.errorText = compareWith.errorText || 'Поля не совпадают';
        errorInfo.errorType = this.errorTypesList.compareWith;
      }
    }

          if (errorInfo.errorType) {
            errorInfo.hasError = true;
          }

          return {
            errorInfo,
          };
        },

        _validatePhone: function (phone: string) {
          return this._checkRegExp(phone, /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
        },

        _validateEmail: function (email: string) {
          return this._checkRegExp(email, /^(([^<>()а-я[\]\\.,;:\s@~`"]+(\.[^<>()а-я[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        },

        _validatePassword: function (password: string) {
          return this._checkRegExp(password, /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$№`!%*?&^#()_+={}\[\]:;"'<>,.?/~|\\-])[A-Za-z\d@$№`!%*?&^#()_+={}\[\]:;"'<>,.?/~|\\-]{8,}$/, true)
        },

        _checkRegExp: (inputValue: string, reg: RegExp, isPassword: boolean = false) => {
          if (!isPassword) {
            return String(inputValue)
              .toLowerCase()
              .match(reg);
          } else {
            return inputValue.match(reg)
          }
        }
      }
    }
  }
})
